// Frontend mirror of sanitizeBranchAlias / derivePreviewUrl (netlify/functions/_lib/github.ts) —
// keep in LOCK-STEP (same pattern as golive.ts / sections.ts). The canonical CF-Pages branch-alias
// rule lowercases, collapses non-alphanumerics to '-', trims, and — critically — TRUNCATES to 28
// chars (then trims a trailing '-'). A naïve `app-${slug}.${project}.pages.dev` skips the 28-char
// cap, so for a long slug (app-<slug> > 28) it builds a URL that doesn't match the real alias →
// a dead link. Use derivePreviewUrl so the launcher opens the actual preview.

export function sanitizeBranchAlias(branch: string): string {
  return branch
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 28)
    .replace(/-+$/g, '');
}

/** The deterministic Cloudflare preview URL for a client's app branch (stable branch alias). */
export function derivePreviewUrl(slug: string, pagesProject: string): string {
  return `https://${sanitizeBranchAlias(`app/${slug}`)}.${pagesProject}.pages.dev`;
}
